import { Resolver } from "react-hook-form";
import { FormDataType } from "../TaskForm";
import { taskFormSchema } from "../Interface/taskFormSchema";
import { baseFormSchema } from "../Interface/baseFormSchema";

// A custom resolver function to handle different schemas (ie the task and assignement)
export function CustomResolver(assignment: boolean): Resolver<FormDataType> {
  const customResolver: Resolver<FormDataType> = async (values) => {
    // Choose the correct schema based on assignment state
    const schema = assignment ? baseFormSchema : taskFormSchema;

    // Use zodResolver with the chosen schema
    try {
      // Run schema validation
      const result = await schema.safeParseAsync(values);

      if (result.success) {
        return {
          values,
          errors: {}
        };
      } else {
        // Convert zod errors to react-hook-form errors
        const errors: Record<string, { type: string; message: string }> = {};
        result.error.errors.forEach(error => {
          const path = error.path.join(".");
          // @ts-ignore - Dynamic property assignment
          errors[path] = {
            type: "validation",
            message: error.message
          };
        });

        return {
          values: {},
          errors
        };
      }
    } catch (e) {
      return {
        values: {},
        errors: {
          root: {
            type: "validation",
            message: "Form validation failed"
          }
        }
      };
    }
  };

  return customResolver;
}
